import "./text-hero-animation";
import "./menu";
import "./tabs";

import "aos/dist/aos.css";
import AOS from "aos";

AOS.init();
